<!-- Modifier selection -->
<div
  class="
    modifier-selection-section
    tw-relative
    tw-w-full
    tw-max-w-[770px]
    tw-overflow-x-auto
    tw-block
    tw-bg-[#E5E5E5]
    tw-rounded-[7px]
    tw-border-[1px]
    tw-border-[#A3A3A3]
    tw-mt-[8px]
    tw-py-[5px]
    tw-px-[12px]
  "
  data-cy="modifier-selection-section"
>
  <div
    class="
      tw-pr-[15px]
      tw-pl-[6px]
    "
  >
    @if (selectedRace !== undefined) {
      <div
        class="
          current-modifiers
          tw-flex
          tw-flex-nowrap
          tw-items-center
          tw-gap-x-[10px]
        "
        data-cy="current-modifiers"
      >

        @if (selectedPool === undefined || selectedPool?.Straight) {
          <span
            [class.active-modifier]="selectedModifier === ''"
            (click)="selectModifier('')"
            data-cy="modifier-straight"
            class="
              modifier-chip
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#19385D]
              tw-rounded-[4px]
              tw-px-[10px]
              tw-py-[5px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#557DAC]
            "
          >
            {{ 'Straight' | translate: 'Straight' }}
          </span>
        }

        @if (
          selectedPool?.Box && ((
            (selectedPool?.PoolRaces||0) * (selectedPool?.Legs||0)
          ) !== 1)
        ) {
          <span
            [class.active-modifier]="selectedModifier === 'BX'"
            (click)="selectModifier('Box')"
            data-cy="modifier-box"
            class="
              modifier-chip
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#19385D]
              tw-rounded-[4px]
              tw-px-[10px]
              tw-py-[5px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#557DAC]
            "
          >
            {{ 'Box' | translate: 'Box' }}
          </span>
        }

        @if (selectedPool?.KeyBox) {
          <span
            [class.active-modifier]="selectedModifier === 'KB'"
            (click)="selectModifier('KeyBox')"
            data-cy="modifier-keybox"
            class="
              modifier-chip
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#19385D]
              tw-rounded-[4px]
              tw-px-[10px]
              tw-py-[5px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#557DAC]
            "
          >
            {{ 'KeyBox' | translate: 'KeyBox' }}
          </span>
        }

        @if (selectedPool?.PowerBox) {
          <span
            [class.active-modifier]="selectedModifier === 'PB'"
            (click)="selectModifier('PowerBox')"
            data-cy="modifier-powerbox"
            class="
              modifier-chip
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#19385D]
              tw-rounded-[4px]
              tw-px-[10px]
              tw-py-[5px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#557DAC]
            "
          >
            {{ 'PowerBox' | translate: 'PowerBox' }}
          </span>
        }

        @if (selectedPool?.KeyWheel) {
          <span
            [class.active-modifier]="selectedModifier === 'KW'"
            (click)="selectModifier('KeyWheel')"
            data-cy="modifier-keywheel"
            class="
              modifier-chip
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#19385D]
              tw-rounded-[4px]
              tw-px-[10px]
              tw-py-[5px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#557DAC]
            "
          >
            {{ 'KeyWheel' | translate: 'KeyWheel' }}
          </span>
        }

        @if (
          selectedEvent?.ToteResponse?.EventDetail?.currentRace !== undefined
          && selectedEvent?.ToteResponse?.EventDetail?.currentRace?.RaceId === selectedRace?.RaceId
          && selectedPool !== undefined
          && selectedPool.PoolId !== undefined
          && poolMatrix?.[selectedPool?.PoolId || '']?.response?.ToteResponse !== undefined
          && poolMatrix?.[selectedPool?.PoolId || '']?.response?.ToteResponse?.Total !== 0
          && (
            selectedPool?.PoolId === 'WIN' ||
            selectedPool?.PoolId === 'EX' ||
            selectedPool?.PoolId === 'DBL' ||
            selectedPool?.PoolId === 'QU'
          )
        ) {
          <span
            [class.active-modifier]="selectedModifier === 'DutchCost'"
            (click)="selectModifier('DutchCost')"
            data-cy="modifier-dutch"
            class="
              modifier-chip
              modifier-chip--green
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-gap-[6px]
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#036E23]
              tw-border-[1px]
              tw-border-[#A5F886]
              tw-rounded-[4px]
              tw-px-[8px]
              tw-py-[4px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#04832A]
            "
          >
            <img
              src="/assets/images/wager/dutch_icon.png"
              alt=""
              aria-hidden="true"
              class="tw-w-[20px] tw-h-[20px] tw-shrink-0"
            />
            <span
              aria-hidden="true"
              class="tw-w-px tw-h-[16px] tw-bg-[#9FABBC] tw-shrink-0"
            ></span>
            <span>{{ 'account.statements.dutch' | translate: 'Dutch' }}</span>
          </span>
        }

        @if ((selectedPool?.Legs||0) * (selectedPool?.PoolRaces||0) > 1) {
          <span
            [class.active-modifier]="selectedModifier === 'ABC'"
            (click)="selectModifier('ABC')"
            data-cy="modifier-abc"
            class="
              modifier-chip
              modifier-chip--green
              tw-inline-flex
              tw-items-center
              tw-justify-center
              tw-gap-[6px]
              tw-text-[#FFFFFF]
              tw-text-[16px]
              sm:tw-text-[18px]
              tw-leading-none
              tw-cursor-pointer
              tw-select-none
              tw-bg-[#036E23]
              tw-border-[1px]
              tw-border-[#A5F886]
              tw-rounded-[4px]
              tw-px-[8px]
              tw-py-[4px]
              tw-transition-colors
              tw-duration-150
              hover:tw-bg-[#04832A]
            "
          >
            <img
              src="/assets/images/wager/abc_icon.png"
              alt=""
              aria-hidden="true"
              class="tw-w-[20px] tw-h-[20px] tw-shrink-0"
            />
            <span
              aria-hidden="true"
              class="tw-w-px tw-h-[16px] tw-bg-[#9FABBC] tw-shrink-0"
            ></span>
            <span>{{ 'ABC' | translate: 'ABC' }}</span>
          </span>
        }
      </div>
    }
  </div>
</div>
